import { InformationCircleIcon } from "@heroicons/react/24/solid";
import ReactTooltip from "react-tooltip";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ApplyTooltip() {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(InformationCircleIcon, {
      "data-tip": true,
      "data-background-color": "#15B8DC",
      "data-for": "apply-tooltip",
      className: "inline h-5 w-5 ml-0 mb-1 mt-4",
      "data-testid": "apply-tooltip",
      fill: "#15B8DC"
    }), /*#__PURE__*/_jsx(ReactTooltip, {
      id: "apply-tooltip",
      place: "bottom",
      type: "dark",
      effect: "solid",
      children: /*#__PURE__*/_jsxs("p", {
        className: "text-xs",
        children: ["Apply the same donation amount ", /*#__PURE__*/_jsx("br", {}), "to all of the projects you currently ", /*#__PURE__*/_jsx("br", {}), "have in your cart. You can also set ", /*#__PURE__*/_jsx("br", {}), "individual donation amounts ", /*#__PURE__*/_jsx("br", {}), "below."]
      })
    })]
  });
}